module.exports = __webpack_public_path__ + "img/ico-survey.7945dafb.svg";